module.exports = __webpack_public_path__ + "img/pop.63f5ce67.png";